import {createAsyncThunk} from "@reduxjs/toolkit";
import ServerData from "../../common/serverData";


export const fetchManagerBuildings = createAsyncThunk(
    'managers/fetchBuildings',
    async (params, {getState, rejectWithValue}) => {
        try {
            const state = getState();
            const accessToken = state.auth.accessToken;
            let client = new ServerData(null, null, {accessToken: accessToken});
            const response = await client.managers.buildings.getAllManagerBuildings();
            return response;
        } catch (e) {
            return rejectWithValue({});
        }
    }
);

export const maintenanceLogin = createAsyncThunk(
    'manager/maintenanceLogin',
    async function({ partnerID, buildingID }, thunkAPI) {
        try {
            const state = thunkAPI.getState();
            const accessToken = state.auth.accessToken;
            if (accessToken == null || accessToken === '') {
                return thunkAPI.fulfillWithValue(null);
            } else {
                // thunkAPI.fulfillWithValue('hjnpuivqk'); // debug only
                const client = new ServerData(null, null, { accessToken });

                let response = {};
                if (partnerID) {
                    response = await client.managers.maintenance.partnerLogin(partnerID);
                } else if (buildingID) {
                    response = await client.managers.maintenance.buildingLogin(buildingID);
                }

                return thunkAPI.fulfillWithValue(response.token);
            }
        } catch (e) {
            const { key, params, message } = e?.response?.data ?? {};
            return thunkAPI.rejectWithValue({ response: { data: { key, params, message } } });
        }
    },
);
